import { combineEpics } from 'redux-observable';

import { createFetchCollectionEpic, mlRel } from 'medialoopster/rest';

export default combineEpics(createFetchCollectionEpic(mlRel('siteexportconfigs'), { version: 3 }));
